import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { useStudioAuth } from './hooks/useStudioAuth';
import { StudioReelsBadgeProvider } from './hooks/useStudioReelsBadge';
import StudioFooter from './components/StudioFooter';
import StudioRail from './components/StudioRail';
import StudioMobileAppProvider, {
  StudioMobileAppBannerHost,
} from './components/StudioMobileAppProvider';
import './studio.css';

const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Serif:wght@500;600;700&family=Russo+One&display=swap';

/**
 * Studio shell — persistent left rail on every `/studio/*` route,
 * collapsing to a bottom bar below the existing `md` breakpoint.
 */
const StudioLayout: React.FC = () => {
  const location = useLocation();
  const { applyQueryMock } = useStudioAuth();

  useEffect(() => {
    document.documentElement.classList.add('dark');
    const existing = document.querySelector(`link[data-studio-fonts="1"]`);
    if (!existing) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = FONT_HREF;
      link.setAttribute('data-studio-fonts', '1');
      document.head.appendChild(link);
    }
  }, []);

  useEffect(() => {
    applyQueryMock(location.search);
  }, [location.search, applyQueryMock]);

  return (
    <StudioReelsBadgeProvider>
      <div className="studio-root" data-testid="studio-root">
        <StudioMobileAppProvider>
          <div className="studio-film-grain" aria-hidden />
          <div className="studio-tape-stripe" aria-hidden />
          <StudioRail />
          <div className="studio-shell">
            <StudioMobileAppBannerHost />
            <main className="studio-main">
              <Outlet />
            </main>
            <StudioFooter />
          </div>
        </StudioMobileAppProvider>
      </div>
    </StudioReelsBadgeProvider>
  );
};

export default StudioLayout;
